import { createSlice } from '@reduxjs/toolkit'
import { escapeCrashBet, getAllRoundHistory, getMyBets, getMyBetsPaginated, getPreviousRoundBets, getTopBets, placedBetCrashGame, verifyProvableFairCrash } from 'redux-store/thunk/crashGame.thunk'
import { APPEND_TYPES, DEFAULT_MY_BETS_LIMIT } from 'utils/constants/index'

const initialState = {
  roundBetResult: null,
  betHistoryData: [],
  resultData: [],
  currentRoundId: '',
  placingOrCashoutLoading: [false, false],
  placedCrashBetId: [null, null],
  currentPlacedBet: [null, null],
  allRoundHistoryData: [],
  allRoundLoading: false,
  myBetsData: {
    bets: [],
    page: 1,
    totalPages: 0
  },
  myBetsDataPaginated: {
    bets: [],
    page: 1,
    totalPages: 0
  },
  myBetsDataPaginatedLoading: false,
  myBetsLoading: false,
  topBetsData: {},
  topBetsLoading: false,
  playerStats: null,
  provableFairData: null,
  previousBetsData: [],
  winningPopupDetails: null
}

const {
  actions: {
    setPlacedBetsData,
    setResultData,
    setCurrentRoundId,
    setPlacedCrashBetId,
    setProvableFairData,
    appendCurrentBetsToMyBets,
    setPlacingOrCashoutLoading,
    setCurrentPlacedBet,
    resetWinningPopupDetails
  },
  reducer
} = createSlice({
  name: 'crashGame',
  initialState,
  reducers: {
    setPlacingOrCashoutLoading: (state, action) => {
      if (action.payload?.index !== undefined && action.payload?.value !== undefined) {
        const index = action.payload?.index ?? 0
        const _loading = [...state.placingOrCashoutLoading]
        _loading[index] = action.payload.value
        return {
          ...state,
          placingOrCashoutLoading: _loading
        }
      }
      return state
    },
    resetWinningPopupDetails: (state, action) => {
      return {
        ...state,
        winningPopupDetails: null
      }
    },
    setPlacedBetsData: (state, action) => {
      return {
        ...state,
        betHistoryData: action.payload
      }
    },
    setResultData: (state, action) => {
      return {
        ...state,
        resultData: action.payload
      }
    },
    setCurrentRoundId: (state, action) => {
      return {
        ...state,
        currentRoundId: action.payload
      }
    },
    setProvableFairData: (state, action) => {
      return {
        ...state,
        provableFairData: action.payload
      }
    },
    setCurrentPlacedBet: (state, action) => {
      if (!action.payload?.reset) {
        const { id, betDetails } = action.payload
        const newPlacedCrashBetId = [...state.currentPlacedBet]
        newPlacedCrashBetId[id] = betDetails
        return {
          ...state,
          currentPlacedBet: newPlacedCrashBetId
        }
      } else {
        return {
          ...state,
          currentPlacedBet: initialState.currentPlacedBet
        }
      }
    },
    setPlacedCrashBetId: (state, action) => {
      if (!action.payload?.reset) {
        const { id, betId } = action.payload
        const newPlacedCrashBetId = [...state.placedCrashBetId]
        newPlacedCrashBetId[id] = betId
        return {
          ...state,
          placedCrashBetId: newPlacedCrashBetId
        }
      } else {
        return {
          ...state,
          placedCrashBetId: initialState.placedCrashBetId
        }
      }
    },
    appendCurrentBetsToMyBets: (state, action) => {
      if (action.payload?.type === APPEND_TYPES.ESCAPE) {
        const escapedBet = action.payload.data
        const betExist = state.myBetsData?.bets?.some(bet => +bet?.id === +escapedBet?.[0]?.id)
        if (!betExist) {
          return {
            ...state,
            winningPopupDetails: { ...escapedBet?.[0] },
            myBetsData: {
              ...state.myBetsData,
              bets: [...escapedBet, ...state.myBetsData?.bets].slice(0, DEFAULT_MY_BETS_LIMIT)
            }
          }
        }
      } else if (action.payload?.type === APPEND_TYPES.ROUND_STOPPED) {
        const userId = action.payload?.userId
        if (userId) {
          const alreadyPresentBetIds = state.myBetsData?.bets?.map(bet => +bet.id)
          const currentPlacedBets = [...state.betHistoryData].filter(bet => (+bet?.userId === +userId && !alreadyPresentBetIds.includes(+bet.id)))
          return {
            ...state,
            myBetsData: {
              ...state.myBetsData,
              bets: [...currentPlacedBets, ...state.myBetsData?.bets].slice(0, DEFAULT_MY_BETS_LIMIT)
            }
          }
        }
      }
      return state
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(placedBetCrashGame.pending, (state, action) => {
        return {
          ...state
        }
      })
      .addCase(placedBetCrashGame.rejected, (state, action) => {
        return {
          ...state
        }
      })
      .addCase(escapeCrashBet.rejected, (state, action) => ({
        ...state,
        roundBetResult: null
      }))
      .addCase(escapeCrashBet.pending, (state, action) => ({
        ...state
      }))
      .addCase(getAllRoundHistory.fulfilled, (state, action) => {
        return {
          ...state,
          allRoundHistoryData: action.payload?.bets,
          allRoundLoading: false
        }
      })
      .addCase(getAllRoundHistory.rejected, (state, action) => {
        return {
          ...state,
          allRoundHistoryData: [],
          allRoundLoading: false
        }
      })

      .addCase(getAllRoundHistory.pending, (state, action) => {
        return {
          ...state,
          allRoundHistoryData: action.payload,
          allRoundLoading: true
        }
      })
      .addCase(getMyBets.pending, (state, action) => {
        return {
          ...state,
          myBetsLoading: true

        }
      })
      .addCase(getMyBets.rejected, (state, action) => {
        return {
          ...state,
          myBetsData: initialState.myBetsData,
          myBetsLoading: false

        }
      })
      .addCase(getMyBets.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: false

        }
      })
      .addCase(getMyBetsPaginated.pending, (state, action) => {
        return {
          ...state,
          myBetsDataPaginatedLoading: true

        }
      })
      .addCase(getMyBetsPaginated.rejected, (state, action) => {
        return {
          ...state,
          myBetsDataPaginated: initialState.myBetsDataPaginated,
          myBetsDataPaginatedLoading: false

        }
      })
      .addCase(getMyBetsPaginated.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsDataPaginated: action.payload,
          myBetsDataPaginatedLoading: false

        }
      })
      .addCase(getPreviousRoundBets.pending, (state, action) => {
        return {
          ...state
        }
      })
      .addCase(getPreviousRoundBets.rejected, (state, action) => {
        return {
          ...state,
          previousBetsData: []

        }
      })
      .addCase(getPreviousRoundBets.fulfilled, (state, action) => {
        return {
          ...state,
          previousBetsData: action.payload
        }
      })
      .addCase(getTopBets.pending, (state, action) => {
        return {
          ...state,
          topBetsLoading: true
        }
      })
      .addCase(getTopBets.fulfilled, (state, action) => {
        return {
          ...state,
          topBetsData: action.payload,
          topBetsLoading: false
        }
      })
      .addCase(getTopBets.rejected, (state, action) => {
        return {
          ...state,
          topBetsData: {},
          topBetsLoading: false
        }
      })
      .addCase(verifyProvableFairCrash.pending, (state, payload) => ({
        ...state,
        loading: true
      }))
      .addCase(verifyProvableFairCrash.fulfilled, (state, { payload }) => ({
        ...state,
        provableFairData: payload,
        loading: false
      }))
      .addCase(verifyProvableFairCrash.rejected, (state, payload) => ({
        ...state,
        loading: false
      }))
  }
})

export default reducer
export {
  setPlacedBetsData,
  setResultData,
  setCurrentRoundId,
  setPlacedCrashBetId,
  setProvableFairData,
  appendCurrentBetsToMyBets,
  setPlacingOrCashoutLoading,
  setCurrentPlacedBet,
  resetWinningPopupDetails
}
